import { filter } from 'ramda';
import { DropdownItemProps } from 'semantic-ui-react';

import { UserType } from 'components/UserMgmt/UserMgmt.context';

import { Format } from './DownloadWidget';

const MAX_ITEMS = 50;

const defaultOptions: DropdownItemProps[] = [
  { key: 1, text: 'CSV', value: 'CSV' },
  { key: 2, text: 'PDF', value: 'PDF' },
  { key: 3, text: 'PNG', value: 'PNG' },
];

const demoOptions: DropdownItemProps[] = [
  { key: 2, text: 'PDF', value: 'PDF' },
  { key: 3, text: 'PNG', value: 'PNG' },
];

const filterOptions = (userType: UserType, userOptions?: Format[]) => {
  const listOptions = userType === 'demo' ? demoOptions : defaultOptions;
  if (userOptions) {
    return filter(
      ({ value }: DropdownItemProps) =>
        !value || userOptions.includes(value as Format),
    )(listOptions);
  }

  return listOptions;
};

const docDefinitions = (imageData: string) => ({
  content: [{ image: imageData, width: 500, alignment: 'center' }],
});

export { MAX_ITEMS, filterOptions, docDefinitions };
